import React from 'react';
import PropTypes from 'prop-types';

const AppContent = ({ children }) => (
  <div className="flex flex-1 pt-10 container max-4xl mx-auto md:py-11 px-4 gap-4 flex-col">
    {children}
  </div>
);

AppContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppContent;
